import React, { useState } from 'react';
import { Modal, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { API_URL } from '../../../config/api';
import styles from './ActionModals.module.scss';

/**
 * 📦 ADD TRACKING MODAL - Modal para Adicionar Código de Rastreio
 * 
 * @param {boolean} show - Controla visibilidade
 * @param {Function} onHide - Callback ao fechar
 * @param {number} saleId - ID da venda
 * @param {Function} onSuccess - Callback após sucesso
 */
const AddTrackingModal = ({ show, onHide, saleId, onSuccess }) => {
  const [formData, setFormData] = useState({
    tracking_code: '',
    shipping_company: 'Correios'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const shippingCompanies = [
    'Correios',
    'Jadlog',
    'Total Express',
    'Loggi',
    'Azul Cargo',
    'Outro'
  ];

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.tracking_code.trim()) {
      setError('Digite o código de rastreio');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${API_URL}/api/sales/${saleId}/tracking`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erro ao adicionar rastreio');
      }

      console.log('✅ Código de rastreio adicionado');

      // Reset e fechar
      setFormData({ tracking_code: '', shipping_company: 'Correios' });
      onHide();
      
      if (onSuccess) {
        onSuccess();
      }

    } catch (err) {
      console.error('❌ Erro ao adicionar rastreio:', err);
      setError(err.message || 'Erro ao adicionar código de rastreio');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      backdrop={false}
      className={styles.actionModal}
      enforceFocus={false}
    >
      <Modal.Header closeButton className={styles.headerTracking}>
        <Modal.Title as="span" className={styles.modalTitle}>
          <Icon icon="mdi:truck-delivery" />
          Adicionar Código de Rastreio
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body className={styles.modalBody}>
          {error && (
            <Alert variant="danger" className="mb-3">
              <Icon icon="mdi:alert-circle" className="me-2" />
              {error}
            </Alert>
          )}

          {/* Transportadora */}
          <Form.Group className="mb-3">
            <Form.Label>
              <Icon icon="mdi:truck" className="me-2" />
              Transportadora
            </Form.Label>
            <Form.Select
              value={formData.shipping_company}
              onChange={(e) => handleChange('shipping_company', e.target.value)}
              disabled={loading}
            >
              {shippingCompanies.map(company => (
                <option key={company} value={company}>
                  {company}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Código de Rastreio */}
          <Form.Group>
            <Form.Label>
              <Icon icon="mdi:barcode" className="me-2" />
              Código de Rastreio *
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Ex: BR123456789BR"
              value={formData.tracking_code}
              onChange={(e) => handleChange('tracking_code', e.target.value.toUpperCase())}
              disabled={loading}
              required
            />
            <Form.Text className="text-muted">
              Digite o código completo de rastreamento
            </Form.Text>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className={styles.modalFooter}>
          <Button
            variant="outline-secondary"
            onClick={onHide}
            disabled={loading}
          >
            <Icon icon="mdi:close" className="me-2" />
            Cancelar
          </Button>
          
          <Button
            variant="primary"
            type="submit"
            disabled={loading || !formData.tracking_code.trim()}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Salvando...
              </>
            ) : (
              <>
                <Icon icon="mdi:content-save" className="me-2" />
                Adicionar Rastreio
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddTrackingModal;

